
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-youtube_2"},[_c('path',{staticClass:"i-Vector",attrs:{"fill":"#798f8f","d":"m7.173 11.11 4.27-2.201-4.27-2.235zM8.77 3.507c3.33 0 5.531.161 5.531.161a2.27 2.27 0 0 1 1.59.644c.374.444.599.993.645 1.571q.157 1.283.16 2.576v1.204a22 22 0 0 1-.16 2.576 2.85 2.85 0 0 1-.644 1.57 2.24 2.24 0 0 1-1.59.645s-2.203.167-5.532.167c-4.108-.032-5.37-.154-5.37-.154-.64 0-1.258-.229-1.745-.644a2.83 2.83 0 0 1-.644-1.571 21 21 0 0 1-.154-2.576v-1.21q-.002-1.293.154-2.576c.045-.578.27-1.128.644-1.571a2.26 2.26 0 0 1 1.584-.644s2.209-.155 5.531-.155z"}})])])
          )
        }
      }
    